// extracted by mini-css-extract-plugin
export default {"followBtn":"friends_followBtn__hPnzF","followingBtn":"friends_followingBtn__VSIho"};